import { render } from "./GestionarAfiliaciones.vue?vue&type=template&id=361bcd74"
import script from "./GestionarAfiliaciones.vue?vue&type=script&lang=js"
export * from "./GestionarAfiliaciones.vue?vue&type=script&lang=js"

import "./GestionarAfiliaciones.vue?vue&type=style&index=0&id=361bcd74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__